export default {
  shoppingcartitems: 'SHOPPINGCARTITEMS_GET_SHOPPINGCARTITEMS',
  shoppingcartitemsPerCategory: 'SHOPPINGCARTITEMS_GET_SHOPPINGCARTITEMS_PER_CATEGORY',
  isSycing: 'SHOPPINGCARTITEMS_GET_SYNCINGSTATE',
  productCounter: 'SHOPPINGCARTITEMS_GET_PRODUCTCOUNTER'
}
